// @ts-nocheck
/*
 * Wholesale shipping line-item properties.
 *
 * Port of the LIVE theme's `bcp-wholesale-price-props.js` to the DEV
 * (Horizon) architecture (vanilla JS, no jQuery).
 *
 * The eeBoo Wholesale shipping app calculates shipping (15% of subtotal +
 * $2.50 admin fee) through a carrier service that reads two HIDDEN line item
 * properties off every cart item:
 *
 *   _actual_price : the real (discounted) unit price in cents — used by the
 *                   shipping calculator to determine the true cost of the item.
 *   _wholesale    : true when the customer is a wholesale customer — tells the
 *                   carrier service to apply the wholesale shipping rate.
 *
 * Without these properties the carrier service sees no wholesale items and
 * returns FREE shipping. The LIVE theme injects them on the cart page via
 * `eeBoo.wsCart.initCheckoutHandler` -> `BOLD.BCP.WholesalePriceProps.init`.
 *
 * This module keeps every cart line item tagged with the correct properties on
 * page load (when the cart is not empty) and whenever the cart changes, so the
 * data is present no matter whether the customer checks out from the cart page
 * or directly from the cart drawer.
 *
 * Properties prefixed with `_` are hidden from the customer in the cart and
 * checkout, so this is invisible to shoppers.
 */
(function () {
  var config = window.eebooWholesale || {};
  var isWholesale = config.isWholesale === true;

  // Guards against overlapping runs (and therefore avoids update loops).
  var syncing = false;

  function cartUrl() {
    var base = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    return base + '.js';
  }

  function changeUrl() {
    return (window.Theme && Theme.routes && Theme.routes.cart_change_url) || '/cart/change.js';
  }

  /**
   * Builds the list of /cart/change.js instructions needed so every line item
   * carries the correct `_actual_price` and `_wholesale` properties. Items that
   * are already correct are skipped, which makes repeated runs idempotent.
   */
  function getChangeInstructions(cart) {
    var desiredWholesale = isWholesale ? 'true' : 'false';

    return cart.items.reduce(function (instructions, item) {
      var props = {};
      // Copy existing properties so we don't drop custom/line-item data.
      if (item.properties) {
        for (var key in item.properties) {
          if (Object.prototype.hasOwnProperty.call(item.properties, key)) {
            props[key] = item.properties[key];
          }
        }
      }

      var needsUpdate = false;

      // Shopify returns/stores line item property values as strings.
      if (parseInt(props._actual_price, 10) !== item.price) {
        props._actual_price = item.price;
        needsUpdate = true;
      }

      if (String(props._wholesale) !== desiredWholesale) {
        props._wholesale = isWholesale;
        needsUpdate = true;
      }

      if (!needsUpdate) return instructions;

      return instructions.concat({
        id: item.key,
        properties: props,
        // Required, otherwise Shopify resets the quantity to 1.
        quantity: item.quantity,
      });
    }, []);
  }

  /**
   * Sends change instructions to Shopify sequentially. Runs as a raw fetch (not
   * through the theme cart manager) so it does NOT dispatch `cart:update` and
   * cannot create a feedback loop.
   */
  function applyInstructions(list, done) {
    if (!list.length) {
      if (done) done();
      return;
    }

    fetch(changeUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(list[0]),
    })
      .then(function () {
        applyInstructions(list.slice(1), done);
      })
      .catch(function () {
        if (done) done();
      });
  }

  function sync() {
    if (syncing) return;
    syncing = true;

    fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) {
          syncing = false;
          return;
        }
        applyInstructions(getChangeInstructions(cart), function () {
          syncing = false;
        });
      })
      .catch(function () {
        syncing = false;
      });
  }

  function init() {
    // Only hit the network on load if there is something in the cart.
    if (config.itemCount > 0) sync();

    // Re-tag whenever the theme updates the cart (add to cart, quantity change,
    // etc.). getChangeInstructions is idempotent, so already-correct items are
    // skipped and this settles after a single pass.
    document.addEventListener('cart:update', function () {
      // Defer so this runs after the theme has finished its own cart request.
      window.setTimeout(sync, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
